<template>
  <div class="activities-container">
    <!-- LIST OF CARDS -->
    <div class="activities-grid">
      <div v-for="inventory in paymentTrue" :key="inventory.public_id" class="activity-card-wrapper">
        <div class="activity-card">
          
          <!-- Image Section -->
          <div class="card-image-wrap" @click="openInfo(inventory)">
            <v-img
              :src="inventory.thumbnail"
              class="card-image"
              aspect-ratio="1.6"
              gradient="to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.15)"
            ></v-img>
            
            <div class="price-badge" v-if="inventory.pricing_status === 'true'">
              From {{ $localCurrency }} {{ $roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount) }}
            </div>
          </div>

          <!-- Body Section -->
          <div class="card-body">
            <div class="title-row">
              <h3 class="card-title earthwerk-font" @click="openInfo(inventory)">
                {{ inventory.name.toUpperCase() }}
              </h3>
              <button class="info-btn" @click="openInfo(inventory)">
                <v-icon small color="#74a533">mdi-information-outline</v-icon>
              </button>
            </div>

            <div class="meta-row">
              <v-icon x-small color="#7b8f6b">mdi-account-group</v-icon>
              <span>Max {{ inventory.maximum_guests || 10 }} guests</span>
            </div>

            <div class="price-row">
              <span class="price-text">
                Adult: {{ $localCurrency }} {{ $roundOff(convert1(inventory.price.currency_type, inventory.price.adult_price).amount) }}
              </span>
              <span class="price-text-small" v-if="inventory.price.child_price > 0">
                · Child: {{ $localCurrency }} {{ $roundOff(convert1(inventory.price.currency_type, inventory.price.child_price).amount) }}
              </span>
            </div>

            <div class="note-row" v-if="inventory.note">
              <v-icon x-small color="#3498db" class="mr-1">mdi-information</v-icon>
              {{ inventory.note }}
            </div>

            <button 
              class="add-btn"
              :disabled="inventory.pricing_status !== 'true'"
              @click="openBookingDialog(inventory)"
            >
              <v-icon small color="white" class="mr-1">mdi-plus</v-icon>
              Add to Booking
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- SKELETON LOADER -->
    <div v-if="!paymentTrue || paymentTrue.length === 0" class="activities-grid">
      <div v-for="n in 6" :key="n" class="activity-card skeleton-card">
        <div class="skeleton-image"></div>
        <div class="card-body">
          <div class="skeleton-line" style="width: 70%"></div>
          <div class="skeleton-line" style="width: 40%; margin-top: 10px;"></div>
          <div class="skeleton-line" style="width: 100%; height: 40px; margin-top: 20px; border-radius: 20px;"></div>
        </div>
      </div>
    </div>

    <!-- INFO DIALOG -->
    <v-dialog v-model="infoDialog" persistent max-width="900px">
      <v-card class="info-dialog">
        <div class="gallery-section">
          <div v-if="infoImages && infoImages.length" class="gallery-container">
            <div class="image-navigation">
              <button class="nav-button prev" :disabled="currentInfoImageIndex === 0" @click="prevInfoImage">
                <v-icon>chevron_left</v-icon>
              </button>
              <div class="image-wrapper">
                <img :src="infoImages[currentInfoImageIndex].path" class="gallery-image" alt="Activity image" />
              </div>
              <button class="nav-button next" :disabled="currentInfoImageIndex === infoImages.length - 1" @click="nextInfoImage">
                <v-icon>chevron_right</v-icon>
              </button>
            </div>
            <div class="image-counter">
              {{ currentInfoImageIndex + 1 }} / {{ infoImages.length }}
            </div>
          </div>
          <div v-else class="single-image-container">
            <img :src="currentInfoInventory ? currentInfoInventory.thumbnail : ''" class="gallery-image" alt="Activity thumbnail" />
          </div>
        </div>

        <v-card-text class="details-section">
          <div class="details-header">
            <h1 class="activity-title earthwerk-font">
              {{ currentInfoInventory ? currentInfoInventory.name.toUpperCase() : '' }}
            </h1>
            <div class="capacity-display">
              <div class="capacity-item">
                <span class="capacity-label">Maximum Capacity:</span>
                <span class="capacity-value">{{ currentInfoInventory ? currentInfoInventory.maximum_guests || 10 : '' }} Guests</span>
              </div>
            </div>
          </div>
          <div class="description-section" v-html="currentInfoInventory ? currentInfoInventory.description : ''" />
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn flat class="earthwerk-font" @click="infoDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- BOOKING DIALOG -->
    <v-dialog v-model="dialog" persistent scrollable max-width="900px">
      <v-card class="booking-dialog">
        <v-card-title class="dialog-header">
          <h2 class="earthwerk-font">ADD TO BOOKING</h2>
          <v-spacer />
          <v-chip v-if="selectedInventory" small color="white" text-color="#74a533" class="progress-chip">
            {{ completedFields }} / {{ totalRequiredFields }} complete
          </v-chip>
        </v-card-title>

        <v-card-text class="dialog-content" style="max-height: 70vh; overflow-y: auto">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-dialog ref="dialog4" v-model="modal3" persistent lazy full-width width="290px" :return-value.sync="activity.activity_date">
                  <v-text-field slot="activator" v-model="activity.activity_date" label="Activity Date *" prepend-icon="event" class="date-input" readonly required />
                  <v-date-picker v-model="activity.activity_date" scrollable :min="minActivityDate" :max="maxActivityDate">
                    <v-spacer />
                    <v-btn flat color="primary" @click="modal3 = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog4.save(activity.activity_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>

              <v-flex v-if="showDates && activity.activity_date" xs12>
                <h4 class="earth-color" style="margin: 10px 0">AVAILABLE SLOTS : {{ Number(activitySlots) }}</h4>
                <v-divider />
              </v-flex>

              <template v-if="selectedInventory && !selectedInventory.ranger_marker">
                <v-flex xs12 sm6>
                  <v-autocomplete v-model="activity.adults" label="Adults" :items="adultSlots_" prepend-icon="person" class="participant-input" :disabled="!activity.activity_date" no-data-text="No Slots Available" />
                </v-flex>
                <v-flex v-if="activity.adults > 0" xs12 sm6>
                  <v-autocomplete v-model="activity.residency_adult" data-field="residency-adult" label="Residency Adult" :items="allAdultConservationFees" :loading="$loadingTrue" item-text="payment_person" item-value="payment_public_id" prepend-icon="location_city" hint="Select where this guest is a resident — this affects conservation fees" persistent-hint :return-object="true" />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete v-model="activity.children" label="Children" :items="childSlots_" prepend-icon="child_friendly" class="participant-input" :disabled="!activity.activity_date" no-data-text="No Slots Available" />
                </v-flex>
                <v-flex v-if="activity.children > 0" xs12 sm6>
                  <v-autocomplete v-model="activity.residency_children" data-field="residency-children" label="Residency Children" :items="allChildrenConservationFees" :loading="$loadingTrue" item-text="payment_person" item-value="payment_public_id" prepend-icon="location_city" hint="Select where this child is a resident — this affects conservation fees" persistent-hint :return-object="true" />
                </v-flex>
              </template>

              <template v-if="selectedInventory && selectedInventory.ranger_marker">
                <v-flex xs12 sm6>
                  <v-autocomplete v-model="activity.adults" label="No of Rangers" :items="adultSlots_" prepend-icon="security" class="participant-input" :disabled="!activity.activity_date" no-data-text="No Slots Available" />
                </v-flex>
                <v-flex v-if="activity.adults > 0" xs12 sm6>
                  <v-autocomplete v-model="activity.residency_adult" data-field="residency-adult" label="Residency Adult" :items="allAdultConservationFees" :loading="$loadingTrue" item-text="payment_person" item-value="payment_public_id" prepend-icon="location_city" hint="Select where this ranger is a resident — this affects conservation fees" persistent-hint :return-object="true" />
                </v-flex>
              </template>

              <template v-if="selectedInventory && selectedInventory.has_extras && !selectedInventory.ranger_marker">
                <v-flex xs12>
                  <v-divider class="my-3" />
                  <h4 class="earth-color">Extra Participants</h4>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="activity.extra_pax_adults" label="Extra Adults" type="number" min="0" prepend-icon="person_add" />
                </v-flex>
                <v-flex v-if="activity.extra_pax_adults > 0" xs12 sm6>
                  <v-autocomplete v-model="activity.residency_extra_adult" data-field="residency-extra-adult" label="Residency Extra Adult" :items="allAdultConservationFees" :loading="$loadingTrue" item-text="payment_person" item-value="payment_public_id" prepend-icon="location_city" hint="Select where this guest is a resident" persistent-hint :return-object="true" />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="activity.extra_pax_children" label="Extra Children" type="number" min="0" prepend-icon="child_care" />
                </v-flex>
                <v-flex v-if="activity.extra_pax_children > 0" xs12 sm6>
                  <v-autocomplete v-model="activity.residency_extra_children" data-field="residency-extra-children" label="Residency Extra Children" :items="allChildrenConservationFees" :loading="$loadingTrue" item-text="payment_person" item-value="payment_public_id" prepend-icon="location_city" hint="Select where this child is a resident" persistent-hint :return-object="true" />
                </v-flex>
              </template>

              <template v-if="selectedInventory && selectedInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7'">
                <v-flex xs12 sm6>
                  <v-select v-model="activity.time_frame" :items="['7:00 PM', '9:00 PM']" label="Select Preferred Time" prepend-icon="access_time" />
                </v-flex>
              </template>

              <template v-if="selectedInventory && needsPickupLocation">
                <v-flex xs12 sm6>
                  <v-select v-model="activity.pick_up_location" data-field="pick-up-location" :items="allPickUpLocations" label="Select Pick Up Location" item-text="location_name" item-value="location_public_id" prepend-icon="location_on" hint="We'll collect you here on the day of the activity" persistent-hint />
                </v-flex>
              </template>

              <v-flex v-if="hasParticipants" xs12>
                <div class="price-summary">
                  <h3 class="earthwerk-font">Price Summary</h3>
                  <div class="price-breakdown">
                    <template v-if="selectedInventory && !selectedInventory.ranger_marker">
                      <div v-if="activity.adults > 0" class="price-line">
                        <span>{{ getResidencyName(activity.residency_adult) }} Adults ({{ activity.adults }} × {{ $localCurrency }} {{ getAdultPrice }})</span>
                        <span>{{ $localCurrency }} {{ calculateAdultTotal }}</span>
                      </div>
                      <div v-if="activity.children > 0" class="price-line">
                        <span>{{ getResidencyName(activity.residency_children) }} Children ({{ activity.children }} × {{ $localCurrency }} {{ getChildPrice }})</span>
                        <span>{{ $localCurrency }} {{ calculateChildTotal }}</span>
                      </div>
                      <div v-if="activity.extra_pax_adults > 0" class="price-line">
                        <span>{{ getResidencyName(activity.residency_extra_adult) }} Extra Adults ({{ activity.extra_pax_adults }} × {{ $localCurrency }} {{ getAdultPrice }})</span>
                        <span>{{ $localCurrency }} {{ calculateExtraAdultTotal }}</span>
                      </div>
                      <div v-if="activity.extra_pax_children > 0" class="price-line">
                        <span>{{ getResidencyName(activity.residency_extra_children) }} Extra Children ({{ activity.extra_pax_children }} × {{ $localCurrency }} {{ getChildPrice }})</span>
                        <span>{{ $localCurrency }} {{ calculateExtraChildTotal }}</span>
                      </div>
                    </template>
                    <template v-if="selectedInventory && selectedInventory.ranger_marker">
                      <div v-if="activity.adults > 0" class="price-line">
                        <span>{{ getResidencyName(activity.residency_adult) }} Rangers ({{ activity.adults }} × {{ $localCurrency }} {{ getAdultPrice }})</span>
                        <span>{{ $localCurrency }} {{ calculateAdultTotal }}</span>
                      </div>
                    </template>
                    <div class="price-total">
                      <strong>Total Amount:</strong>
                      <strong>{{ $localCurrency }} {{ calculateTotalPrice }}</strong>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn flat class="cancel-btn earthwerk-font" @click="closeDialog">Cancel</v-btn>
          <v-tooltip left :disabled="isFormValid" content-class="warning-tooltip">
            <template v-slot:activator="{ on }">
              <div v-on="on" style="display: inline-block;">
                <v-btn color="primary" class="reserve-btn earthwerk-font" :disabled="isSubmitBlocked" @click="addToReservationCart">Add to Booking</v-btn>
              </div>
            </template>
            <span>{{ disabledReason }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Activities',
  data() {
    return {
      dialog: false,
      infoDialog: false,
      currentInfoInventory: null,
      currentInfoImageIndex: 0,
      modal3: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      showDates: false,
      selectedInventory: null,
      // 🔹 Reactive mirror of localStorage.booking (dates only)
      storedBooking: {
        check_in: '',
        check_out: '',
        days: 0
      },
      activity: {
        activity_date: '',
        children: 0,
        adults: 0,
        extra_pax_adults: 0,
        extra_pax_children: 0,
        inventory: {},
        time_frame: '',
        pick_up_location: '',
        residency_adult: {},
        residency_children: {},
        residency_extra_adult: {},
        residency_extra_children: {},
      },
    }
  },
  created() {
    this.$store.dispatch('get_active_activities')
    this.$store.dispatch('get_all_pick_up_locations')
    this.$store.dispatch('get_all_gates')
    this.$store.dispatch('get_full_conservation_fees')

    // 🔹 Read dates from localStorage.booking (single source of truth)
    this.loadDatesFromStorage()
    this.loadGuestsFromStorage()

    // Listen for cross-tab changes to `booking`
    window.addEventListener('storage', this.handleBookingStorageChange)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleBookingStorageChange)
  },
  computed: {
    hasBookingDates() {
      return !!(this.storedBooking.check_in && this.storedBooking.check_out)
    },
    minActivityDate() {
      if (this.hasBookingDates) return this.storedBooking.check_in
      return this.start_date
    },
    maxActivityDate() {
      if (this.hasBookingDates) {
        return this.$moment(this.storedBooking.check_out).subtract(1, 'days').format('YYYY-MM-DD')
      }
      return null
    },
    bookingDays() {
      return this.storedBooking.days || 0
    },

    // GUESTS — read from localStorage.guests (written by NewBooking.vue)
    storedGuestCounts() {
      try {
        const guests = JSON.parse(localStorage.getItem('guests') || '{}')
        return {
          adults: Number(guests.adults || 0),
          children: Number(guests.children || 0),
          total: Number(guests.total || ((guests.adults || 0) + (guests.children || 0)))
        }
      } catch (e) {
        return { adults: 0, children: 0, total: 0 }
      }
    },
    hasStoredGuests() {
      return this.storedGuestCounts.total > 0
    },

    paymentTrue() {
      const activeInventory = []
      const allActivities = this.allActivities || []
      for (var i = 0; i < allActivities.length; i++) {
        var data = allActivities[i]
        if (data.pricing_status === 'true' && data.thumbnail !== null) {
          activeInventory.push(data)
        }
      }
      return activeInventory
    },
    allActivities() {
      return this.$store.state.ActivityStore ? this.$store.state.ActivityStore.active_activities || [] : []
    },
    allGates() {
      return this.$store.state.GateStore ? this.$store.state.GateStore.all_gates || [] : []
    },
    infoImages() {
      return this.$store.state.ActivityStore ? this.$store.state.ActivityStore.activity_images || [] : []
    },
    allPickUpLocations() {
      if (this.$store.state.PickUpLocationStore && this.$store.state.PickUpLocationStore.all_pick_up_locations) {
        return this.$store.state.PickUpLocationStore.all_pick_up_locations
      }
      return []
    },
    conservationFeesRaw() {
      if (this.$store.state.ConservationFeeStore) {
        return this.$store.state.ConservationFeeStore.conservation_fees || []
      }
      return []
    },
    needsPickupLocation() {
      return (
        this.selectedInventory &&
        (this.selectedInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7' ||
          this.selectedInventory.public_id === '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' ||
          this.selectedInventory.public_id === '66e52cab-43cd-4974-85de-246a731d6905')
      )
    },
    childSlots_() {
      const slots = []
      const available = this.calculateChildMax_
      for (var i = 0; i <= available; i++) slots.push(i)
      return slots
    },
    adultSlots_() {
      const slots = []
      const available = this.calculateAdultMax_
      for (var i = 0; i <= available; i++) slots.push(i)
      return slots
    },
    calculateAdultMax_() {
      return Number(this.activitySlots) - Number(this.total) + Number(this.activity.adults)
    },
    calculateChildMax_() {
      return Number(this.activitySlots) - Number(this.total) + Number(this.activity.children)
    },
    totalParticipants() {
      return Number(this.activity.adults) + Number(this.activity.children) +
        Number(this.activity.extra_pax_adults) + Number(this.activity.extra_pax_children)
    },
    total() {
      return Number(this.activity.adults) + Number(this.activity.children)
    },
    activitySlots() {
      if (this.$store.state.BookingStore) {
        const slots = Number(this.$store.state.BookingStore.activity_slots)
        return slots > 0 ? slots : 0
      }
      return 0
    },

    getAdultPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      return this.$roundOff(
        this.convert1(
          this.selectedInventory.price.currency_type,
          this.selectedInventory.price.adult_price
        ).amount
      )
    },
    getChildPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      return this.$roundOff(
        this.convert1(
          this.selectedInventory.price.currency_type,
          this.selectedInventory.price.child_price
        ).amount
      )
    },
    calculateAdultTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.adults * this.selectedInventory.price.adult_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateChildTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.children * this.selectedInventory.price.child_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateExtraAdultTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.extra_pax_adults * this.selectedInventory.price.adult_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateExtraChildTotal() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      const baseTotal = this.activity.extra_pax_children * this.selectedInventory.price.child_price
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, baseTotal).amount
      )
    },
    calculateTotalPrice() {
      if (!this.selectedInventory || !this.selectedInventory.price) return 0
      let total = 0
      if (!this.selectedInventory.ranger_marker) {
        total = this.activity.adults * this.selectedInventory.price.adult_price +
          this.activity.children * this.selectedInventory.price.child_price +
          this.activity.extra_pax_adults * this.selectedInventory.price.adult_price +
          this.activity.extra_pax_children * this.selectedInventory.price.child_price
      } else {
        total = this.activity.adults * this.selectedInventory.price.adult_price
      }
      return this.$roundOff(
        this.convert1(this.selectedInventory.price.currency_type, total).amount
      )
    },
    hasParticipants() {
      return this.activity.adults > 0 || this.activity.children > 0 ||
        this.activity.extra_pax_adults > 0 || this.activity.extra_pax_children > 0
    },
    isFormValid() {
      if (!this.activity.activity_date) return false
      if (this.activity.adults === 0 && this.activity.children === 0 &&
          this.activity.extra_pax_adults === 0 && this.activity.extra_pax_children === 0) return false

      if (this.activity.adults > 0 && !this.hasResidency(this.activity.residency_adult)) return false
      if (this.activity.children > 0 && !this.hasResidency(this.activity.residency_children)) return false
      if (this.activity.extra_pax_adults > 0 && !this.hasResidency(this.activity.residency_extra_adult)) return false
      if (this.activity.extra_pax_children > 0 && !this.hasResidency(this.activity.residency_extra_children)) return false

      if (this.needsPickupLocation && !this.activity.pick_up_location) return false

      return true
    },
    isSubmitBlocked() {
      return !this.activity.activity_date && !this.hasParticipants
    },
    disabledReason() {
      const err = this.getFirstValidationError()
      return err ? err.message : ''
    },
    completedFields() {
      let done = 0
      if (this.activity.activity_date) done++
      if (this.hasParticipants) done++
      if (this.activity.adults === 0 || this.hasResidency(this.activity.residency_adult)) done++
      if (this.activity.children === 0 || this.hasResidency(this.activity.residency_children)) done++
      if (this.activity.extra_pax_adults === 0 || this.hasResidency(this.activity.residency_extra_adult)) done++
      if (this.activity.extra_pax_children === 0 || this.hasResidency(this.activity.residency_extra_children)) done++
      if (!this.needsPickupLocation || this.activity.pick_up_location) done++
      return done
    },
    totalRequiredFields() {
      return this.needsPickupLocation ? 7 : 6
    },
  },
  watch: {
    'activity.activity_date'(newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.selectedInventory) {
        this.findAvailability()
      }
    },
    activitySlots(newVal) {
      const available = Number(newVal) || 0
      if (available === 0) {
        this.activity.adults = 0
        this.activity.children = 0
        this.activity.extra_pax_adults = 0
        this.activity.extra_pax_children = 0
        return
      }
      let remaining = available
      if (this.activity.extra_pax_adults > remaining) this.activity.extra_pax_adults = remaining
      remaining -= Number(this.activity.extra_pax_adults)
      if (this.activity.extra_pax_children > remaining) this.activity.extra_pax_children = remaining
      remaining -= Number(this.activity.extra_pax_children)
      if (this.activity.adults > remaining) this.activity.adults = remaining
      remaining -= Number(this.activity.adults)
      if (this.activity.children > remaining) this.activity.children = remaining
    },
  },
  methods: {
    hasResidency(val) {
      return val && Object.keys(val).length > 0
    },

    // 🔹 Read dates only from localStorage.booking
    loadDatesFromStorage() {
      try {
        const booking = JSON.parse(localStorage.getItem('booking') || '{}')
        this.storedBooking = {
          check_in: booking.check_in || '',
          check_out: booking.check_out || '',
          days: booking.days || 0
        }
        if (this.storedBooking.check_in) {
          this.activity.activity_date = this.storedBooking.check_in
        }
      } catch (e) {
        this.storedBooking = { check_in: '', check_out: '', days: 0 }
      }
    },

    // Cross-tab storage listener
    handleBookingStorageChange(event) {
      if (event.key === 'booking') {
        this.loadDatesFromStorage()
        if (this.activity.activity_date && this.selectedInventory) {
          this.findAvailability()
        }
      }
    },

    // GUESTS — from localStorage.guests, with conservation_data as fallback
    getStorageAdults() {
      try {
        const guests = JSON.parse(localStorage.getItem('guests') || '{}')
        if (guests.adults !== undefined && guests.adults !== null && guests.adults !== '') {
          return Number(guests.adults || 0)
        }
      } catch (e) {}
      try {
        const conservation = JSON.parse(localStorage.getItem('conservation_data') || '[]')
        if (Array.isArray(conservation) && conservation.length > 0) {
          return conservation.reduce(function (sum, fee) {
            const type = fee.payment_person ? fee.payment_person.toLowerCase() : ''
            if (type.includes('child') || type.includes('infant')) return sum
            return sum + Number(fee.payment_guests || 0)
          }, 0)
        }
      } catch (e) {}
      return 0
    },
    getStorageChildren() {
      try {
        const guests = JSON.parse(localStorage.getItem('guests') || '{}')
        if (guests.children !== undefined && guests.children !== null && guests.children !== '') {
          return Number(guests.children || 0)
        }
      } catch (e) {}
      try {
        const conservation = JSON.parse(localStorage.getItem('conservation_data') || '[]')
        if (Array.isArray(conservation) && conservation.length > 0) {
          return conservation.reduce(function (sum, fee) {
            const type = fee.payment_person ? fee.payment_person.toLowerCase() : ''
            if (!type.includes('child')) return sum
            if (type.includes('infant')) return sum
            return sum + Number(fee.payment_guests || 0)
          }, 0)
        }
      } catch (e) {}
      return 0
    },
    loadGuestsFromStorage() {
      const adults = this.getStorageAdults()
      const children = this.getStorageChildren()
      if (adults > 0 || children > 0) {
        this.activity.adults = adults
        this.activity.children = children
      }
    },

    getResidencyName(residency) {
      return residency && residency.payment_person ? residency.payment_person : ''
    },

    openInfo(inventory) {
      this.currentInfoInventory = inventory
      this.currentInfoImageIndex = 0
      this.$store.dispatch('get_activity_images', inventory.public_id)
      this.infoDialog = true
    },
    prevInfoImage() {
      if (this.currentInfoImageIndex > 0) this.currentInfoImageIndex--
    },
    nextInfoImage() {
      if (this.currentInfoImageIndex < this.infoImages.length - 1) this.currentInfoImageIndex++
    },

    openBookingDialog(inventory) {
      this.selectedInventory = inventory
      this.resetActivityForm()
      this.$store.commit('REMOVE_AVAILABILITY')

      const storedAdults = this.getStorageAdults()
      const storedChildren = this.getStorageChildren()

      if (storedAdults > 0 || storedChildren > 0) {
        if (!this.selectedInventory.ranger_marker) {
          this.activity.adults = storedAdults
          this.activity.children = storedChildren
        } else {
          this.activity.adults = storedAdults
        }
      }

      if (this.hasBookingDates && !this.activity.activity_date) {
        this.activity.activity_date = this.storedBooking.check_in
      }

      this.dialog = true
      this.$store.dispatch('get_activity', inventory.public_id)
      this.$store.dispatch('get_full_conservation_fees')

      if (this.activity.activity_date && this.selectedInventory) {
        this.$nextTick(() => {
          this.findAvailability()
        })
      }
    },

    findAvailability() {
      this.$store.dispatch('loading_true')
      const data = {
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        inventory_id: this.selectedInventory.public_id,
      }
      this.$store.dispatch('check_inventory_availability', data)
      const priceData = {
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        public_id: this.selectedInventory.public_id,
      }
      this.$store.dispatch('get_activity_with_pricing', priceData)
      this.showDates = true
    },

    showNotification(type, title, text) {
      if (this.$notify) {
        this.$notify({ type, group: 'foo', title, text, classes: 'alert-wrapper' })
      }
    },

    getFirstValidationError() {
      if (!this.activity.activity_date) return { message: 'Please select an activity date.', selector: '.date-input' }
      if (!this.hasParticipants) return { message: 'Please add at least one participant.', selector: '.participant-input' }
      if (this.activity.adults > 0 && !this.hasResidency(this.activity.residency_adult)) return { message: 'Please select adult residency.', selector: '[data-field="residency-adult"]' }
      if (this.activity.children > 0 && !this.hasResidency(this.activity.residency_children)) return { message: 'Please select children residency.', selector: '[data-field="residency-children"]' }
      if (this.activity.extra_pax_adults > 0 && !this.hasResidency(this.activity.residency_extra_adult)) return { message: 'Please select extra adult residency.', selector: '[data-field="residency-extra-adult"]' }
      if (this.activity.extra_pax_children > 0 && !this.hasResidency(this.activity.residency_extra_children)) return { message: 'Please select extra children residency.', selector: '[data-field="residency-extra-children"]' }
      if (this.needsPickupLocation && !this.activity.pick_up_location) return { message: 'Please select a pick up location.', selector: '[data-field="pick-up-location"]' }
      return null
    },

    addToReservationCart() {
      const firstError = this.getFirstValidationError()
      if (firstError) {
        this.showNotification('warning', 'Almost there', firstError.message)
        this.$nextTick(() => {
          const el = document.querySelector(firstError.selector)
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
        return
      }

      this.activity.inventory = this.selectedInventory
      this.activity.inventory.price = this.$store.state.ActivityStore.activity_price_at_time
      this.activity.inventory.public_id = this.selectedInventory.public_id

      const cartItem = {
        public_id: this.selectedInventory.public_id,
        name: this.selectedInventory.name,
        date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
        adults: this.activity.adults,
        adult_price: this.selectedInventory.price.adult_price,
        child_price: this.selectedInventory.price.child_price,
        currency: this.selectedInventory.price.currency_type,
        children: this.activity.children,
        ranger_marker: this.selectedInventory.ranger_marker,
        activity_discount: 0,
        discounts: this.selectedInventory.discount || 0,
        discount_status: this.selectedInventory.discount_status || false,
        extra_pax_adults: this.activity.extra_pax_adults,
        extra_pax_children: this.activity.extra_pax_children,
        time_frame: this.activity.time_frame,
        pick_up_location: this.activity.pick_up_location,
        residency_children: this.activity.residency_children,
        residency_adult: this.activity.residency_adult,
        residency_extra_adult: this.activity.residency_extra_adult,
        residency_extra_children: this.activity.residency_extra_children,
      }

      const oldData = JSON.parse(localStorage.getItem('activity_data') || '[]')
      let existingIndex = -1
      for (let i = 0; i < oldData.length; i++) {
        if (oldData[i].public_id === cartItem.public_id && oldData[i].date === cartItem.date) {
          existingIndex = i
          break
        }
      }
      if (existingIndex !== -1) oldData[existingIndex] = cartItem
      else oldData.push(cartItem)

      localStorage.setItem('activity_data', JSON.stringify(oldData))
      this.$store.commit('CHOSEN_ACTIVITIES', oldData)
      this.$root.$emit('cart-updated')
      this.$emit('activity-added', cartItem)

      this.showNotification('success', 'Activity Added', this.selectedInventory.name + ' has been added to your booking')
      this.closeDialog()
    },

    closeDialog() {
      this.dialog = false
      this.resetActivityForm()
      this.$store.commit('REMOVE_AVAILABILITY')
    },

    resetActivityForm() {
      this.activity = {
        activity_date: this.hasBookingDates ? this.storedBooking.check_in : '',
        children: 0,
        adults: 0,
        extra_pax_adults: 0,
        extra_pax_children: 0,
        inventory: {},
        time_frame: '',
        pick_up_location: '',
        residency_adult: {},
        residency_children: {},
        residency_extra_adult: {},
        residency_extra_children: {},
      }
      this.showDates = false
    },
  },
}
</script>
<style scoped>
@font-face {
  font-family: 'Earthwerk';
  src: url('PizzaDude.dk-Earthwerk.otf');
  font-weight: normal;
  font-style: normal;
}

/* Constrain the width so it doesn't stretch on big screens */
.activities-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* RESPONSIVE GRID */
.activities-grid {
  display: grid;
  grid-template-columns: 1fr; /* Mobile: 1 column */
  gap: 16px;
}

@media (min-width: 600px) {
  .activities-grid {
    grid-template-columns: repeat(2, 1fr); /* Tablet: 2 columns */
  }
}

@media (min-width: 960px) {
  .activities-grid {
    grid-template-columns: repeat(3, 1fr); /* Desktop: 3 columns */
  }
}

/* ---------- CARD ---------- */
.activity-card {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(165, 214, 167, 0.4);
  box-shadow: 0 6px 18px -8px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%; /* Make all cards in a row equal height */
}

.activity-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 26px -10px rgba(0, 0, 0, 0.3);
}

.card-image-wrap {
  position: relative;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
}

.card-image {
  border-radius: 0 !important;
  display: block;
  transition: transform 0.4s ease;
}

.activity-card:hover .card-image {
  transform: scale(1.04);
}

.price-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #8cc63f;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  letter-spacing: 0.2px;
}

.card-body {
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  flex: 1; /* Pushes the button to the bottom */
}

.title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.card-title {
  flex: 1;
  margin: 0;
  font-family: 'Earthwerk', sans-serif;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 700;
  color: #2d4a1e;
  letter-spacing: 0.4px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.15s ease;
}

.card-title:hover {
  color: #74a533;
}

.info-btn {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #eef3e8;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;
}

.info-btn:hover {
  background: #dbe8cc;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 11.5px;
  color: #7b8f6b;
}

.price-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin-top: 8px;
}

.price-text {
  font-weight: 700;
  font-size: 13px;
  color: #74a533;
}

.price-text-small {
  font-size: 12px;
  color: #7b8f6b;
  margin-left: 4px;
}

.note-row {
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  background: #eaf4fd;
  color: #24618b;
  border-left: 3px solid #3498db;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
}

.add-btn {
  width: 100%;
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #74a533;
  color: #fff;
  font-family: 'Earthwerk', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 12px 20px;
  border: none;
  border-radius: 40px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(116, 165, 51, 0.3);
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  margin-top: auto; /* Pushes to bottom of flex container */
}

.add-btn:active {
  transform: scale(0.98);
}

.add-btn:disabled {
  background: #dce5d4;
  box-shadow: none;
  cursor: not-allowed;
}

/* Skeleton Loader */
.skeleton-card {
  pointer-events: none;
}
.skeleton-image {
  width: 100%;
  height: 180px;
  background: #eef1f4;
  animation: pulse 1.5s infinite;
}
.skeleton-line {
  height: 16px;
  background: #eef1f4;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* Dialogs (Keep existing styles) */
.earthwerk-font {
  font-family: 'Earthwerk', sans-serif;
  color: #333;
  font-size: 20px;
  line-height: 1.3;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}
.activity-title {
  transition: color 0.2s ease;
  font-size: 18px;
}
.capacity-display {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}
.capacity-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.capacity-label {
  font-size: 16px;
  color: #666;
}
.capacity-value {
  font-size: 18px;
  font-weight: 600;
  color: #74a533;
}
.earth-color { color: #74a533; }
.info-icon { cursor: pointer; color: #666; margin-left: 10px; vertical-align: middle; }
.info-icon:hover { color: #74a533; }

.info-dialog,
.booking-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.gallery-section {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}
.gallery-container, .single-image-container { width: 100%; height: 400px; }
.image-navigation { display: flex; align-items: center; justify-content: space-between; height: 100%; position: relative; }
.image-wrapper { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
.gallery-image { width: 100%; height: 100%; object-fit: cover; display: block; }
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
}
.nav-button:hover { background: rgba(255, 255, 255, 0.9); }
.nav-button:disabled { opacity: 0.5; cursor: not-allowed; }
.nav-button.prev { left: 20px; }
.nav-button.next { right: 20px; }
.image-counter {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  z-index: 10;
}
.details-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.details-header { margin-bottom: 25px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
.description-section { color: #555; line-height: 1.8; font-size: 16px; margin-bottom: 30px; }
.description-section >>> p { margin-bottom: 15px; }
.description-section >>> a { color: #74a533; text-decoration: none; }
.description-section >>> a:hover { text-decoration: underline; }

.dialog-header {
  background-color: #74a533;
  color: white;
  padding: 20px 24px;
  display: flex;
  align-items: center;
}
.dialog-header h2 { font-family: 'Earthwerk', sans-serif; font-size: 24px; margin: 0; }
.progress-chip { font-weight: 600; letter-spacing: 0.3px; }
.dialog-content { padding: 24px; }
.date-input { margin-bottom: 15px; }
.participant-input { margin-bottom: 15px; }
.price-summary { margin-top: 25px; padding: 15px; background-color: #f9f9f9; border-radius: 8px; }
.price-breakdown { margin-top: 10px; }
.price-line { display: flex; justify-content: space-between; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #eee; }
.price-total { display: flex; justify-content: space-between; margin-top: 10px; padding-top: 10px; border-top: 2px solid #74a533; font-size: 16px; }
.requirements-list { list-style: none; padding-left: 0; margin: 8px 0 0 0; }
.requirements-list li { display: flex; align-items: center; gap: 6px; padding: 4px 0; font-size: 14px; color: #555; }
.dialog-actions { padding: 16px 24px; border-top: 1px solid #eee; }
.cancel-btn { margin-right: 10px; }
.reserve-btn { font-weight: 600; letter-spacing: 0.5px; }

/* Mobile Adjustments */
@media (max-width: 600px) {
  .card-body { padding: 12px 14px 14px; }
  .card-title { font-size: 14px; }
  .price-badge { font-size: 11px; padding: 4px 10px; top: 10px; left: 10px; }
  .price-text { font-size: 12px; }
  .price-text-small { font-size: 11px; }
  .add-btn { font-size: 13px; padding: 10px 16px; }
  
  .gallery-container, .single-image-container { height: 250px; }
  .nav-button { width: 35px; height: 35px; }
  .nav-button.prev { left: 10px; }
  .nav-button.next { right: 10px; }
  .image-counter { font-size: 12px; padding: 3px 10px; }
}
</style>
<style>
.warning-tooltip {
  background-color: #ff9800 !important;
  color: #ffffff !important;
  font-weight: 600;
  opacity: 1 !important;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.warning-tooltip::after {
  border-top-color: #ff9800 !important;
}
</style>